import { render, staticRenderFns } from "./AppInputTelefone.vue?vue&type=template&id=0e238c9c&scoped=true"
import script from "./AppInputTelefone.vue?vue&type=script&lang=js"
export * from "./AppInputTelefone.vue?vue&type=script&lang=js"
import style0 from "./AppInputTelefone.vue?vue&type=style&index=0&id=0e238c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e238c9c",
  null
  
)

export default component.exports